<template>
  <span v-html="formattedPrice" />
</template>

<script>
export default {
  name: 'FormatPrice',

  props: {
    price: {
      type: Object,
      required: true,
    },

    disabled: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      formattedPrice: '',
    };
  },

  watch: {
    price: {
      immediate: true,
      deep: true,
      async handler(p) {
        let selectedIntl;
        if (!window.Intl || typeof window.Intl.NumberFormat.prototype.formatToParts !== 'function') {
          // default IE11 polyfill doesn't support Intl.NumberFormat.formatToParts()
          const [intl] = await Promise.all([
            import(/* webpackChunkName: "IntlPolyfill" */ 'intl'),
            import(/* webpackChunkName: "IntlPolyfill" */ 'intl/locale-data/jsonp/en'),
            import(/* webpackChunkName: "IntlPolyfill" */ 'intl/locale-data/jsonp/de'),
          ]);
          selectedIntl = intl.default;
        } else {
          selectedIntl = Intl;
        }

        const formatter = new selectedIntl.NumberFormat(this.$i18n.locale, {
          style: 'currency',
          currency: p.currency,
        });

        this.formattedPrice = formatter
          .formatToParts(p.value)
          .map(({ type, value }) => {
            if (type === 'fraction' && !this.disabled) {
              return `<sup>${value}</sup>`;
            } else {
              return value;
            }
          })
          .reduce((string, part) => string + part);
      },
    },
  },
};
</script>
